import React, { useEffect, useState } from "react";
import ViewJobStatusStyle from "./ViewJobStatus.styles";
import {
  Breadcrumb,
  BreadcrumbItem,
  Heading,
  Button,
  useSnackbar,
} from "@livingdesign/react";
import { Refresh } from "@livingdesign/icons";
import MuiDataTable from "../../../components/Table/MuiDataTable/MuiDataTable";
import { BULK_OPERATION_FOR, BULK_OPERATION_TYPE, COMMENT, COMPLETE, COMPLETED_TIME, INVOICE, INVOICE_LINE_ITEM, JOB_COMMANDS, JOB_COMPLETED_ON, JOB_CREATED_ON, JOB_STATUS, MATTER, RESUBMIT_INVOICE, STATUS, SUBMITTED_TIME, TASK, TITLE, UPLOAD_INVOICE } from "../../../constants/constants";
import { REFRESH } from "../../../constants/actionButtons";
import { getColorVariant, getErrorMessage } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { JOB_SERVICE } from "../../../constants/baseURLs";
import { setJobStatusDetail } from "../../../store/actions/jobStatusActions";
import { DATE_MMMM_D_YYYY_HH_AT_MM_A } from "../../../constants/dateFormats";
import { displayLocalDate } from "../../../helpers/utcUtils";
import LoadComponent from "../../../components/LoadComponent/LoadComponent";
import { getService } from "../../../axios/axios";
import MuiTagItem from "../../../components/Table/MuiDataTable/MuiTagItem/MuiTagItem";
import { useParams, useHistory } from "react-router-dom";
import { ERROR_CODES, ERROR_CODES_FOR_PROCESS_STATUS, PROCESS_ERROR_CODES_KEY } from "../../../constants/errorCodes";
import { TableCellDisplay, renderStatus } from "../../../helpers/commonUtils";
import { PROCESS_STATUS_RESUBMIT_MSG, PROCESS_STATUS_UPLOAD_INVOICE_MSG, PROCESS_STATUS_UPLOAD_INVOICE_MSG2 } from "../../../constants/messages";
import { FEATURES } from "../../../constants/features";

const ViewJobStatus = () => {
  const classes = ViewJobStatusStyle();
  const featureMap = useSelector((state) => state?.user?.featureMap);
  const {
    title,
    description,
    status,
    command,
    submittedTs,
    jobFinishTs,
    id, //TODO Should be changed later to jobCode
    jobTasks,
    jobNumber } = useSelector(state => state?.processStatus?.jobStatusDetail);
  const COLUMNS = [
    {
      name: "serial",
      label: "Serial #",
      colKey: "serial",
      options: {
        setCellProps: () => ({ style: { maxWidth: "75px", minWidth: "75px" } }),
        setCellHeaderProps: () => ({ style: { maxWidth: "75px", minWidth: "75px" } }),
        customBodyRender: (value, tableMeta, update) => {
          const rowIndex = Number(tableMeta.rowIndex) + 1;
          return TableCellDisplay(`table-row-serial-${tableMeta.rowIndex}`, rowIndex)
        }
      }
    },
    {
      name: "taskIdentifier",
      label: (JOB_COMMANDS?.[command]?.type === "Invoice") ? "Invoice #" : "Identifier",
      colKey: "taskIdentifier",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return value;
        },
      }
    },
    {
      name: "status",
      label: "Status",
      colKey: "status",
      options: {
        setCellHeaderProps: () => ({ style: { minWidth: "100px" } }),
        customBodyRender: renderStatus,
      }
    },
    {
      name: "bulkOperationType",
      label: "bulkOperationType",
      colKey: "bulkOperationType",
      options: {
        display: false,
      }
    },
    {
      name: "apiCallResponse",
      label: "Comment",
      colKey: "apiCallResponse",
      options: {
        setCellHeaderProps: () => ({ style: { minWidth: "100px" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          if (tableMeta?.rowData[2] === "Failed") {
            const apiCallResponse = JSON.parse(value)
            if (tableMeta?.rowData[3] === MATTER) {
              const errorMessage = JSON.parse(apiCallResponse?.body)?.params?.errmsg;
              return errorMessage;
            } else if (tableMeta?.rowData[3] === INVOICE) {
              const errorMessage = JSON.parse(apiCallResponse?.body)
              if (errorMessage?.errorCode === "LNG_DUPLICATE_INVOICE_REQUEST") {
                return ERROR_CODES?.[errorMessage?.errorCode]
              } else if (PROCESS_ERROR_CODES_KEY.includes(errorMessage?.errorCode)) {
                return ERROR_CODES_FOR_PROCESS_STATUS?.[errorMessage?.errorCode];
              } else {
                return errorMessage?.message
              }
            }
            else if (tableMeta?.rowData[3] === INVOICE_LINE_ITEM) {
              const errorMessage = apiCallResponse
              if (ERROR_CODES?.[errorMessage?.errorCode]) {
                return ERROR_CODES?.[errorMessage?.errorCode]
              } else if (PROCESS_ERROR_CODES_KEY.includes(errorMessage?.errorCode)) {
                return ERROR_CODES_FOR_PROCESS_STATUS?.[errorMessage?.errorCode];
              } else {
                return errorMessage?.message
              }
            }
          }
          else {
            return "-"
          }
        },
      },
    },
  ];

  const [Columns, setColumns] = useState(COLUMNS);
  const { jobId } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { addSnack } = useSnackbar();
  const dispatch = useDispatch();
  const { color, variant } = getColorVariant(status);

  const loadComponentProps = {
    loader: loading,
    skeletonHeight: '26px',
    skeletonWidth: '100%',
    skeletonVariant: 'reactangle',
    skeletonLines: 1
  };

  useEffect(() => {
    viewJobStatus()
  }, [])

  /*
* Function to get details of specific Job ID
*/
  const viewJobStatus = () => {
    setLoading(true);
    getService(JOB_SERVICE, `/search/jobs/v1/${jobId}`)
      .then((res) => {
        const data = res?.data;
        const type = JOB_COMMANDS?.[res?.data?.command]?.type;
        data?.jobTasks?.forEach(job => {
          job["bulkOperationType"] = type;
        });
        dispatch(setJobStatusDetail(res?.data))
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        addSnack({
          message: getErrorMessage(error)
        });
      });
  }

  const refreshJobStatusDetail = () => {
    viewJobStatus()
  }

  const headerForUploadInvoice = () => {
    return (
      <>
        <div className={classes.gridLayout}>
          <div className={classes.pageInfo}>
            <div className={classes.label}>
              <text>
                {STATUS}
              </text>
            </div>
            <div className={classes.pageInfoBold}>
              <Heading as="h4" size="small">
                <LoadComponent {...loadComponentProps}>
                  <MuiTagItem value={status === COMPLETE ? 'Success' : status} color={color} variant={variant} />
                </LoadComponent>
              </Heading>
            </div>
          </div>
          <div className={classes.pageInfo}>
            <div className={classes.label}>
              <text>
                {BULK_OPERATION_FOR}
              </text>
            </div>
            <div className={classes.pageInfoBold}>
              <Heading as="h4" size="small">
                <LoadComponent {...loadComponentProps}>
                  {JOB_COMMANDS?.[command]?.type}
                </LoadComponent>
              </Heading>
            </div>
          </div>
          <div className={classes.pageInfo}>
            <div>
              <text className={classes.label}>
                {TASK}
              </text>
            </div>
            <div className={classes.pageInfoBold}>
              <Heading as="h4" size="small">
                <LoadComponent {...loadComponentProps}>
                  {title}
                </LoadComponent>
              </Heading>
            </div>
          </div>
          <div className={classes.pageInfo}>
            <div className={classes.label}>
              <text>
                {COMMENT}
              </text>
            </div>
            <div className={classes.pageInfoComment} >
              <LoadComponent {...loadComponentProps}>
                {description}
              </LoadComponent>
            </div>
          </div>
          <div className={classes.pageInfo}>
            <div className={classes.label}>
              <text>
                {JOB_CREATED_ON}
              </text>
            </div>
            <div className={classes.pageInfoBold}>
              <Heading as="h4" size="small">
                <LoadComponent {...loadComponentProps}>
                  {displayLocalDate(submittedTs, DATE_MMMM_D_YYYY_HH_AT_MM_A)}
                </LoadComponent>
              </Heading>
            </div>
          </div>
          <div className={classes.pageInfo}>
            <div className={classes.label}>
              <text>
                {JOB_COMPLETED_ON}
              </text>
            </div>
            <div className={classes.pageInfoBold}>
              <Heading as="h4" size="small">
                <LoadComponent {...loadComponentProps}>
                  {displayLocalDate(jobFinishTs, DATE_MMMM_D_YYYY_HH_AT_MM_A)}
                </LoadComponent>
              </Heading>
            </div>
          </div>
        </div>
        <div className={classes.uploadInvoiceMsg}>
          <LoadComponent {...loadComponentProps}>
            {PROCESS_STATUS_UPLOAD_INVOICE_MSG}<a onClick={() => history.push(`/financial`, { currentFinancialTab: 1 })} className={classes.hyperLink}>{"Invoice Page. "}</a>{PROCESS_STATUS_UPLOAD_INVOICE_MSG2}
          </LoadComponent>
        </div>
      </>
    )
  }

  return (
    <div className={classes.listing}>
      <Breadcrumb>
        <BreadcrumbItem onClick={() => history.push(`/financial`, { currentFinancialTab: 2 })} data-testid="job-status-breadcrumb">{JOB_STATUS}</BreadcrumbItem>
        <BreadcrumbItem isCurrent>{jobNumber}</BreadcrumbItem>
      </Breadcrumb>
      <div className={classes.parentHeader}>
        <Heading as="h1" size="large">
          <LoadComponent {...loadComponentProps}>
            #{jobNumber}
          </LoadComponent>
        </Heading>
        <div className={classes.refreshButton}>
          <Button
            trailing={<Refresh size="small" />}
            size="small"
            variant="primary"
            data-testid="refresh-datatable"
            id="refresh-datatable"
            onClick={refreshJobStatusDetail}
          >
            {REFRESH}
          </Button>
        </div>
      </div>
      {title === UPLOAD_INVOICE ? headerForUploadInvoice() :
        <>
          <div className={classes.gridLayout}>
            <div className={classes.pageInfo}>
              <div>
                <text className={classes.label}>
                  {TITLE}
                </text>
              </div>
              <div className={classes.pageInfoBold}>
                <Heading as="h4" size="small">
                  <LoadComponent {...loadComponentProps}>
                    {title}
                  </LoadComponent>
                </Heading>
              </div>
            </div>
            <div className={classes.pageInfo}>
              <div className={classes.label}>
                <text>
                  {STATUS}
                </text>
              </div>
              <div className={classes.pageInfoBold}>
                <Heading as="h4" size="small">
                  <LoadComponent {...loadComponentProps}>
                    <MuiTagItem value={status === COMPLETE ? 'Success' : status} color={color} variant={variant} />
                  </LoadComponent>
                </Heading>
              </div>
            </div>
            <div className={classes.pageInfo}>
              <div className={classes.label}>
                <text>
                  {SUBMITTED_TIME}
                </text>
              </div>
              <div className={classes.pageInfoBold}>
                <Heading as="h4" size="small">
                  <LoadComponent {...loadComponentProps}>
                    {displayLocalDate(submittedTs, DATE_MMMM_D_YYYY_HH_AT_MM_A)}
                  </LoadComponent>
                </Heading>
              </div>
            </div>
            <div className={classes.pageInfo}>
              <div className={classes.label}>
                <text>
                  {COMPLETED_TIME}
                </text>
              </div>
              <div className={classes.pageInfoBold}>
                <Heading as="h4" size="small">
                  <LoadComponent {...loadComponentProps}>
                    {displayLocalDate(jobFinishTs, DATE_MMMM_D_YYYY_HH_AT_MM_A)}
                  </LoadComponent>
                </Heading>
              </div>
            </div>
            <div className={classes.pageInfo}>
              <div className={classes.label}>
                <text>
                  {BULK_OPERATION_TYPE}
                </text>
              </div>
              <div className={classes.pageInfoBold}>
                <Heading as="h4" size="small">
                  <LoadComponent {...loadComponentProps}>
                    {JOB_COMMANDS?.[command]?.type}
                  </LoadComponent>
                </Heading>
              </div>
            </div>
            <div className={classes.pageInfo}>
              <div className={classes.label}>
                <text>
                  {COMMENT}
                </text>
              </div>
              <div className={classes.pageInfoComment} >
                <LoadComponent {...loadComponentProps}>
                  {description}
                </LoadComponent>
              </div>
            </div>
          </div>
          {(title === RESUBMIT_INVOICE && featureMap?.[FEATURES.INVOICE_PRE_VALIDATION]) && <div className={classes.uploadInvoiceMsg}>
            <LoadComponent {...loadComponentProps}>
              {PROCESS_STATUS_RESUBMIT_MSG}
            </LoadComponent>
          </div>}
        </>
      }
      <MuiDataTable
        data={jobTasks}
        loading={loading}
        columns={Columns}
        setTableColumns={setColumns}
        disableExport={true}
        disableSearch={true}
        hideAddNewButton={true}
        disableFilter={true}
      />
    </div>)
};

export default ViewJobStatus;
